import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
const GetOrdersInPipelineStage = graphql(`
  query GetOrdersInPipelineStage(
    $tenantId: ID!
    $pipelineId: ID!
    $pipelineStageId: ID!
    $customerIdentifier: String!
  ) {
    order {
      getMany(
        tenantId: $tenantId
        pipelineId: $pipelineId
        pipelineStageId: $pipelineStageId
        customerIdentifier: $customerIdentifier
      ) {
        edges {
          node {
            id
            cart {
              price {
                net
                gross
              }
            }
          }
        }
      }
    }
  }
`);
export default GetOrdersInPipelineStage;
